import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { trackCreditApplicationEvent } from '../../../../actions/tracking';
import { creditApplicationEvents } from '../../../../shared/tracking';
import { getSearchDocument } from '../../../../utils/reselectors';

interface UseTrackCreditApplicationOptions {
  downPayment: number;
  residual?: number;
  duration: number;
  financialInstitution: string;
}

const useTrackCreditApplication = (options: UseTrackCreditApplicationOptions) => {
  const dispatch = useDispatch();
  const track = bindActionCreators(trackCreditApplicationEvent, dispatch);

  const item = useSelector(getSearchDocument);

  const getTrackEventPayload = () => ({
    financialOptionsDetails: {
      deposit: options.downPayment,
      residualValuePercentage: options.residual,
      paybackTime: options.duration,
      financialInstitution: options.financialInstitution,
    },
  });

  const trackInit = () => track(creditApplicationEvents.INIT, item, getTrackEventPayload());

  const trackSubmitted = () =>
    track(creditApplicationEvents.SUBMITTED, item, getTrackEventPayload());

  return {
    trackInit,
    trackSubmitted,
  };
};

export default useTrackCreditApplication;
